export default __webpack_public_path__ + "static/media/faultyTractorIcon.fa522f54.svg";